
define('css!ui/switch/css/switch',[],function(){});
